<textarea matInput class="fback text" [placeholder]="display_placeholder" [(ngModel)]="_model" (ngModelChange)="ngModelChange()">
  </textarea>